module.exports = __webpack_public_path__ + "e9b2f4ba095591e4e9c58e82f9b288f7.svg";